export const RedirectLogin= process.env.PUBLIC_URL

export const Sleep=(ms)=>{
    return new Promise(resolve => setTimeout(resolve, ms));
  }